<template>
  <div class="browser-window bg-dirty">
    <div class="browser-window__tabs">
      <span class="content"
        ><span v-if="project.name" class="text-dblue-600"
          >{{ project.name }} Feedback</span
        ><span v-else class="text-dblue-400">New project Feedback</span>
      </span>
    </div>
    <div class="browser-window__url">
      <span class="content"
        ><span class="text-dblue-300">https://</span
        ><span v-if="project.url" class="text-dblue-500 font-medium">{{
          project.url
        }}</span
        ><span v-else class="text-dblue-300">new-project</span
        ><span class="text-dblue-500">.feedbear.com</span></span
      >
    </div>
    <div class="browser-window__body">
      <img :src="logoPreview" alt="" v-if="project.logo" class="logo-preview" />
      <div class="browser-window__project-name" v-else>
        <span v-if="project.name" class="text-dblue-600">{{
          project.name
        }}</span>
        <span v-else class="text-dblue-400">New project</span>
      </div>

      <div class="flex">
        <div class="navbox mt-2 w-16 mr-1" v-if="activeStep <= 2"></div>

        <transition name="fadeIn" mode="out-in">
          <div
            class="navbox mt-2 w-20"
            v-if="activeStep === 0"
            key="navbox"
          ></div>
          <div
            class="text-sm text-dblue-600 ml-1 mt-1 leading-tight font-medium"
            key="text"
            v-else
          >
            {{ board.name }}
          </div>
        </transition>
      </div>

      <div class="flex items-start mt-3">
        <div class="col mr-1 w-1/3">
          <transition name="fadeIn" mode="out-in">
            <div
              class="textbox h-3 w-16"
              v-if="activeStep <= 1"
              key="placeholder"
            ></div>
            <div
              class="text-dblue-400 font-medium text-sm leading-none"
              key="newpost"
              v-else
            >
              New idea
            </div>
          </transition>

          <div class="textbox h-24 w-full mt-2"></div>
          <div class="textbox h-5 w-12 mt-2 mx-auto"></div>
        </div>
        <div class="col ml-1 w-2/3">
          <div class="post">
            <span class="post__title" v-if="firstPost">{{
              firstPost.title
            }}</span>
            <span
              class="post__status"
              :class="statusClass(firstPost.status)"
              v-if="firstPost"
              >{{ firstPost.human_status }}</span
            >
          </div>
          <div class="post">
            <span class="post__title" v-if="secondPost">{{
              secondPost.title
            }}</span>
            <span
              class="post__status"
              :class="statusClass(secondPost.status)"
              v-if="secondPost"
              >{{ secondPost.human_status }}</span
            >
          </div>
          <div class="post">
            <span class="post__title" v-if="thirdPost">{{
              thirdPost.title
            }}</span>
            <span
              class="post__status"
              :class="statusClass(thirdPost.status)"
              v-if="thirdPost"
              >{{ thirdPost.human_status }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["project", "board", "posts", "activeStep","statusName"],

  data() {
    return {};
  },

  methods: {
    statusClass: function (status) {
      if (status === this.statusName.planned) {
        return "text-planned";
      }

      if (status === this.statusName.in_progress) {
        return "text-in_progress";
      }

      if (status === this.statusName.done) {
        return "text-done";
      }
    },
  },

  computed: {
    logoPreview() {
      return URL.createObjectURL(this.project.logo);
    },

    firstPost() {
      if (this.posts.first.title) {
        return this.posts.first;
      }

      if (this.posts.second.title) {
        return this.posts.second;
      }

      if (this.posts.third.title) {
        return this.posts.third;
      }
    },

    secondPost() {
      if (this.posts.first.title && this.posts.second.title) {
        return this.posts.second;
      }

      if (
        this.posts.first.title &&
        !this.posts.second.title &&
        this.posts.third.title
      ) {
        return this.posts.third;
      }

      if (
        !this.posts.first.title &&
        this.posts.second.title &&
        this.posts.third.title
      ) {
        return this.posts.third;
      }
    },

    thirdPost() {
      if (
        this.posts.first.title &&
        this.posts.second.title &&
        this.posts.third.title
      ) {
        return this.posts.third;
      }
    },
  },
};
</script>

<style scoped>
.fadeIn-enter,
.fadeIn-leave-to {
  opacity: 0;
}

.fadeIn-enter-to,
.fadeIn-leave {
  opacity: 1;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  @apply transition duration-200 ease-in;
}

.browser-window {
  height: 21rem;
  @apply rounded-lg w-full max-w-lg mx-auto shadow-lg flex flex-col;
}

.browser-window__tabs {
  @apply bg-dblue-200 h-10 w-full flex items-end rounded-t-md;
}

.browser-window__tabs .content {
  line-height: 2rem;
  @apply flex items-center h-8 w-48 bg-dblue-100 ml-2 rounded-t px-2 text-sm text-dblue-500 ring-1 ring-black ring-opacity-5 relative z-10;
}

.browser-window__tabs .content span {
  overflow: hidden;
  display: block;
  max-height: 100%;
  word-break: break-all;
}

.browser-window__tabs .content::before {
  content: "";
  right: 0;
  top: 0;
  width: 2rem;
  background: linear-gradient(90deg, rgba(234, 236, 238, 0), #eaecee);
  @apply absolute h-full rounded-tr;
}

.browser-window__tabs .content::after {
  content: "";
  height: 1px;
  bottom: -1px;
  left: 0;
  @apply block absolute w-full bg-dblue-100;
}

.browser-window__url {
  @apply w-full h-10 bg-dblue-100 flex items-center relative z-0 ring-1 ring-black ring-opacity-5;
}

.browser-window__url .content {
  line-height: 1.5rem;
  @apply block h-6 w-full mx-2 rounded-full bg-white px-2 text-sm;
}

.browser-window__body {
  @apply pt-2 px-3;
}

.logo-preview {
  max-width: 7rem;
  max-height: 2rem;
}

.browser-window__project-name {
  @apply text-base;
}

.navbox {
  @apply bg-dblue-200 rounded h-3;
}

.textbox {
  @apply bg-dblue-100 rounded;
}

.col {
  @apply bg-white shadow-sm rounded p-2 relative;
}

.post {
  height: 2.4rem;
  @apply border-2 border-dblue-100 rounded m-1 bg-white text-sm px-2 flex flex-col justify-center;
}

.post__title {
  @apply text-sm text-dblue-500 leading-tight;
}

.post__status {
  @apply text-xs font-medium leading-none;
}

.text-planned {
  color: #5a73c1;
}

.text-in_progress {
  color: #05867b;
}

.text-done {
  color: #0b8200;
}
</style>
